// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomTxCardFieldDefinitionsCardWrite from './data'

export default function DataVaxiomTxCardFieldDefinitionsCardWriteFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite">
      <DataVaxiomTxCardFieldDefinitionsCardWrite {...props}>
        {children}
      </DataVaxiomTxCardFieldDefinitionsCardWrite>
    </Flow>
  )
}
